<template>
    <div v-if="visible" role="alertdialog" class="p-confirm-popup p-component" aria-modal="true" id="confirm"
        aria-label="popup" data-pc-name="confirmpopup" data-pc-section="root" data-pd-focustrap="true"
        :style="positionStyles">
        <!-- Triangle Pointer -->
        <div class="triangle-pointer"></div>
        <span class="p-hidden-accessible p-hidden-focusable" tabindex="0" role="presentation" aria-hidden="true"
            data-p-hidden-accessible="true" data-p-hidden-focusable="true"
            data-pc-section="firstfocusableelement"></span>
        <div class="p-confirm-popup-content" data-pc-section="content">
            <span class="p-confirm-popup-message" data-pc-section="message">{{ displayMessage }}</span>
        </div>
        <div class="p-confirm-popup-footer rounded-lg" data-pc-section="footer">
            <button class="p-button p-component p-confirm-popup-reject p-button-sm p-button-text" type="button"
                aria-label="No" @click="hide"><span class="p-button-label">Não</span></button>
            <button class="p-button p-component p-confirm-popup-accept p-button-sm" type="button" aria-label="Yes"
                @click="accept"><span class="p-button-label">Sim</span></button>
        </div>
        <span class="p-hidden-accessible p-hidden-focusable" tabindex="0" role="presentation" aria-hidden="true"
            data-p-hidden-accessible="true" data-p-hidden-focusable="true"
            data-pc-section="lastfocusableelement"></span>
    </div>
</template>

<script>
export default {
    name: 'MyConfirmPopUp',
    props: {
        message: {
            type: String,
            default: 'Tem certeza de que deseja continuar?'
        },
    },

    data() {
        return {
            visible: false,
            target: null,
            confirmationStep: 1,
            displayMessage: '',
            secondMessage: 'Deseja copiar as permissões deste tipo de utilizador?',
            acceptedFirstMessage: false,
            acceptedSecondMessage: false,
            positionStyles: {
                top: '0px',
                left: '0px',
                position: 'absolute',
                zIndex: '1001',
                transformOrigin: 'center top'
            }
        };
    },
    methods: {
        show(target) {
            this.target = target;
            this.updatePosition();
            this.visible = true;
            this.displayMessage = this.message;
            window.addEventListener('scroll', this.updatePosition, true);
            window.addEventListener('resize', this.updatePosition);
        },
        hide() {
            this.visible = false;
            if(!this.acceptedSecondMessage && this.acceptedFirstMessage){
                this.$emit('accept-one');
            }
            this.resetState();
            window.removeEventListener('scroll', this.updatePosition, true);
            window.removeEventListener('resize', this.updatePosition);
        },
        updatePosition() {
            if (this.target) {
                const targetRect = this.target.getBoundingClientRect();
                this.positionStyles = {
                    ...this.positionStyles,
                    top: `${window.scrollY + targetRect.bottom}px`,
                    left: `${window.scrollX + targetRect.left + targetRect.width / 2 - 60}px` // Adjust for popup width
                };
            }
        },
        // accept() {
        //     this.$emit('accept');
        //     this.hide();
        // }
        accept() {
            if (this.confirmationStep === 1 && this.displayMessage === 'Adicionar tipo de utilizador?') {
                this.acceptedFirstMessage = true; // User accepts the first message
                this.confirmationStep = 2;
                this.displayMessage = this.secondMessage; // Update the display message
            } else if (this.confirmationStep === 2 && this.displayMessage === this.secondMessage) {
                this.acceptedSecondMessage = true; // User accepts the second message
                // Here, you can check if both messages were accepted
                if (this.acceptedFirstMessage && this.acceptedSecondMessage) {
                    this.$emit('accept-both');
                    // Perform actions based on acceptance of both messages
                    this.hide();
                } 
            } else {
                this.$emit('accept');
                this.hide();
                this.resetState();
            }
        },
        resetState() {
        this.confirmationStep = 1; // Reset to initial step
        this.displayMessage = this.message; // Reset to initial message or clear it
        this.acceptedFirstMessage = false; // Reset acceptance flags
        this.acceptedSecondMessage = false;
    },

    }
}
</script>

<style scoped>
.p-confirm-popup {
    margin-top: 8px;
    background: #626288;
    color: white;
    border: 0 none;
    border-radius: 10px;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    /* width: 120px; */
}

.p-confirm-popup-content {
    padding: 1rem;
}

.p-confirm-popup-footer {
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 1rem;
    gap: 0.5rem;
}

.p-button {
    font-size: 14px;
    padding: 0.5rem 0.75rem;
    /* border: 1px solid #dee2e6; */
    border-radius: 8px;
    cursor: pointer;
}

.p-confirm-popup-reject {
    background-color: rgba(255, 0, 0, 0.792);
    color: white;
}

.p-confirm-popup-accept {
    background-color: rgb(255, 155, 5);
    color: white;
}

/* Triangle Pointer */
.triangle-pointer {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid #626288;
    position: absolute;
    left: 15%;
    transform: translateX(-50%);
    top: -10px;
}
</style>
